import './Spinner.scss';
import CircularProgress from '../CircularProgress/CircularProgress';

/**
 * Spinner
 *
 * Componente minimalista de pantalla completa para mostrar estado de carga.
 * Muestra únicamente un spinner circular animado centrado sobre fondo blanco.
 * 
 * Diseñado para usarse durante la inicialización de la app.
 *
 * @param {Object} props - Las propiedades del componente
 * @param {'yellow'|'black'|'white'} [props.variant='yellow'] - Variante de color del spinner
 * @param {number} [props.size=60] - Tamaño del spinner en píxeles
 * @returns {JSX.Element}
 *
 * @example
 * <Spinner variant="yellow" size={60} />
 */
const Spinner = ({
  variant = 'yellow',
  size = 60
}) => {
  return (
    <div className="spinner-container" data-testid="spinner-container">
      <CircularProgress size={size} variant={variant} />
    </div>
  );
};

export default Spinner;